import React, { useState, forwardRef } from 'react';
import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';
import useOfflineGoalData from '@api/hooks/enquiry/useOfflineGoalData';
import useWindowSize from '@hooks/useWindowSize';
import Image from '@base/Image';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import EnquiryStaticInfo from './EnquiryStaticInfo';
import EnquiryForm from './EnquiryForm';
import EnquiryThankyou from './EnquiryThankYou';
import EnquiryStaticInfoImage from './EnquiryStaticInfoImage';
import EnquiryStaticInfoOfferings from './EnquiryStaticInfoOfferings';

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  background-color: var(--color-i-white-99);
  margin-top: ${Spacings.SPACING_20B};
  position: relative;
  z-index: 0;
  ${mediaQuery.uptoTablet} {
    margin-top: ${Spacings.SPACING_10B};
  }
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_10B};
  }
`;

const EnquiryFormWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: auto;
  gap: ${Spacings.SPACING_16B};
  width: 1136px;
  z-index: 1;
  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    align-items: start;
    width: 100%;
    gap: ${Spacings.SPACING_6B};
    padding: 0px ${Spacings.SPACING_4B} 0px ${Spacings.SPACING_4B};
  }
`;

const LoaderWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

const ImageWrapper = styled.div`
  width: 475px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  ${mediaQuery.uptoTablet} {
    display: none;
  }
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

// eslint-disable-next-line react/display-name
const AllCentreEnquiry = forwardRef((props, ref) => {
  const { cmsData } = props;

  const { offlineGoals, isGoalDataLoading } = useOfflineGoalData();
  const isLoading = isGoalDataLoading;

  const { isMobile } = useWindowSize();
  const [thankyouPage, showThankyouPage] = useState(false);
  const goalsData = [];
  offlineGoals?.goal_uids?.forEach((uid, index) =>
    goalsData.push({
      id: index + 1,
      value: uid,
      label: offlineGoals.goal_names[index]
    })
  );

  if (isLoading) {
    return (
      <Container>
        <EnquiryFormWrapper>
          <LoaderWrapper>
            <CircularLoader />
          </LoaderWrapper>
        </EnquiryFormWrapper>
      </Container>
    );
  }

  return (
    <div ref={ref}>
      <Container>
        {isMobile ? (
          <EnquiryFormWrapper>
            <EnquiryStaticInfoImage cmsData={cmsData} />
            {thankyouPage ? (
              <EnquiryThankyou />
            ) : (
              <EnquiryForm
                cmsData={cmsData}
                offlineGoals={goalsData}
                showThankyouPage={showThankyouPage}
              />
            )}
            <EnquiryStaticInfoOfferings cmsData={cmsData} />
          </EnquiryFormWrapper>
        ) : (
          <>
            <EnquiryFormWrapper>
              <EnquiryStaticInfo />
              {thankyouPage ? (
                <EnquiryThankyou />
              ) : (
                <EnquiryForm
                  cmsData={cmsData}
                  offlineGoals={goalsData}
                  showThankyouPage={showThankyouPage}
                />
              )}
            </EnquiryFormWrapper>
            <ImageWrapper>
              <Image
                src="allCentre/EnquiryFormBg.svg"
                alt="all-centre-enquiry-form"
                layout="fill"
              />
            </ImageWrapper>
          </>
        )}
      </Container>
    </div>
  );
});

export default AllCentreEnquiry;
